import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import classnames from 'classnames';
import Signup from 'sharedFreePages/Signup';
import Onboarding from 'sharedFreePages/Onboarding';
import AwaitProvision from 'sharedFreePages/AwaitProvision';
import { useGlobalState } from 'hooks/useGlobalState';
import { useMunchkinTracking } from 'hooks/useMunchkinTracking';
import styles from '../PageContent/PageContent.module.scss';

export default function SharedFreePageContent() {
  const [{ signup, waitingScreen }] = useGlobalState();
  useMunchkinTracking();
  return (
    <div
      className={classnames(styles.contentContainer, {
        [styles.noScroll]: waitingScreen.visible,
      })}
    >
      <Routes>
        <Route exact path="/" element={<Signup />} />
        <Route
          path="/onboarding"
          element={signup.status ? <Onboarding /> : <Navigate to="/" />}
        />
        <Route
          path="/awaitProvision"
          element={signup.status ? <AwaitProvision /> : <Navigate to="/" />}
        />
      </Routes>
    </div>
  );
}
